import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { getWarehouses } from '../lib/api';
import { useAuth } from './AuthContext';

const WarehouseContext = createContext(null);

export function useWarehouse() {
  const ctx = useContext(WarehouseContext);
  if (!ctx) throw new Error('useWarehouse must be used within WarehouseProvider');
  return ctx;
}

export function WarehouseProvider({ children }) {
  const { isAuthenticated } = useAuth();
  const [warehouses, setWarehouses] = useState([]);
  const [currentWarehouseId, setCurrentWarehouseId] = useState(
    localStorage.getItem('stockaris_warehouse_id') || null
  );

  const refreshWarehouses = useCallback(async () => {
    if (!isAuthenticated) return;
    try {
      const res = await getWarehouses();
      setWarehouses(res.data);
      if (!currentWarehouseId && res.data.length > 0) {
        const def = res.data.find(w => w.is_default) || res.data[0];
        setCurrentWarehouseId(def.id);
        localStorage.setItem('stockaris_warehouse_id', def.id);
      }
    } catch (e) {
      console.error('Failed to load warehouses:', e);
    }
  }, [isAuthenticated, currentWarehouseId]);

  useEffect(() => {
    refreshWarehouses();
  }, [refreshWarehouses]);

  const switchWarehouse = (id) => {
    setCurrentWarehouseId(id);
    localStorage.setItem('stockaris_warehouse_id', id);
  };

  const currentWarehouse = warehouses.find(w => w.id === currentWarehouseId);

  return (
    <WarehouseContext.Provider value={{
      warehouses,
      currentWarehouse,
      currentWarehouseId,
      switchWarehouse,
      refreshWarehouses,
    }}>
      {children}
    </WarehouseContext.Provider>
  );
}
